import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { CommunicationProps } from './Communication';
import MessageSettingsTab from './MessageSettingsTab';
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { Divider } from '@mui/material';
import { countries } from '../localization/LanguageSelector';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from "@mui/material/Tooltip";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface MessageSettingsLayoutProps extends CommunicationProps {
    emailIndicator:boolean;
    smsIndicator:boolean;
    appIndicator:boolean;
}

const MessageSettingsLayout = (props: MessageSettingsLayoutProps) => {
    const [value, setValue] = React.useState(0);
    const [expanded, setExpanded] = React.useState(0);
    const [lang, setLang] = useState('en');

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleChangeLang = (event: SelectChangeEvent) => {
        setLang(event.target.value as string);
    };

    return (
        <Accordion style={{ border: "0.25pt solid lightgray", width: 750, margin: "auto" }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header">

                Message Settings
            </AccordionSummary>
            <Divider />
            <AccordionDetails>
                <Box >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        
                        {/* select language control */}
                        <Box sx={{ maxWidth: 100, float:"right", marginTop:"10px"}}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Lang</InputLabel>
                                <Select
                                sx={{height:30}}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={lang}
                                    label="Lang"
                                    onChange={handleChangeLang}
                                    MenuProps={{
                                        PaperProps: {
                                          style: {
                                            maxHeight: 200, // Set the maximum height of the dropdown
                                          },
                                        },
                                      }}
                                >
                                    {/* list all possible languages this app supports */}
                                    {countries.map((country)=>{
                                        return (
                                            <MenuItem key = {country.language} value={country.language}>{country.language}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        </Box>
                        {/* tabs */}
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label={<Tooltip title={props.emailIndicator ? "This communication is currently set to deliver emails" : "Email communications not configured!"}>
                                <span style={{color:props.emailIndicator ? "green" : "gray"}}><EmailIcon />{props.emailIndicator && <CheckCircleIcon color="success" style={{fontSize:"14pt", marginBottom:"17px", marginLeft:"-5px"}}/>}&nbsp;&nbsp;Email
                                 </span>
                                 </Tooltip>} {...a11yProps(0)} />
                            <Tab label={<Tooltip title={props.smsIndicator ? "This communication is currently set to deliver SMS" : "SMS communications not configured!"}>
                                <span style={{color:props.smsIndicator ? "green" : "gray"}}><SmsIcon />{props.smsIndicator && <CheckCircleIcon color="success" style={{fontSize:"14pt", marginBottom:"17px", marginLeft:"-5px"}}/>}&nbsp;&nbsp;SMS
                                </span>
                                </Tooltip>} {...a11yProps(1)} />
                            <Tab label={<Tooltip title={props.appIndicator ? "This communication is currently set to deliver tp the app!" : "App communications not configured!"}>
                                <span style={{color:props.appIndicator ? "green" : "gray"}}><AppSettingsAltIcon />{props.appIndicator && <CheckCircleIcon color="success" style={{fontSize:"14pt", marginBottom:"17px", marginLeft:"-5px"}}/>}&nbsp;&nbsp;App
                                </span>
                                </Tooltip>} {...a11yProps(2)} />
                        </Tabs>


                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <MessageSettingsTab handleCopyCommunication={props.handleCopyCommunication} prioritiesList={[]} selectedLang={lang} selectedMedium={"email"} communication={props.communication} handleUpdateCommunication={props.handleUpdateCommunication} handleDeleteCommunication={props.handleDeleteCommunication} editMode={props.editMode} />
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                        <MessageSettingsTab handleCopyCommunication={props.handleCopyCommunication} prioritiesList={[]} selectedLang={lang} selectedMedium={"sms"} communication={props.communication} handleUpdateCommunication={props.handleUpdateCommunication} handleDeleteCommunication={props.handleDeleteCommunication} editMode={props.editMode} />

                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <MessageSettingsTab handleCopyCommunication={props.handleCopyCommunication} prioritiesList={[]} selectedLang={lang} selectedMedium={"app"} communication={props.communication} handleUpdateCommunication={props.handleUpdateCommunication} handleDeleteCommunication={props.handleDeleteCommunication} editMode={props.editMode} />

                    </CustomTabPanel>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}
export default MessageSettingsLayout